import styled, { AnyStyledComponent } from 'styled-components';
import { LabelProps, InputProps } from './checkbox.types';
import FONTS from '../../style/fonts';
import COLORS from '../../style/universal.color';
import { IconWrapper } from '../Icon/icon.style';

// Hide checkbox visually but remain accessible to screen readers.
export const HiddenCheckbox: AnyStyledComponent = styled.input.attrs({
  type: 'checkbox'
})`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

export const Label = styled.label`
  cursor: pointer;
  user-select: none;
`;

export const Pill: AnyStyledComponent = styled(Label)`
  height: 32px;
  min-width: 32px;
  line-height: 32px;
  padding-left: 10px;
  padding-right: 10px;
  display: inline-block;
  box-sizing: border-box;
  text-align: center;
  font-family: ${FONTS.primaryFont};
  font-size: 13px;
  font-weight: bold;
  background: ${COLORS.transparent};
  border: 1px solid ${COLORS.mlbGrey2};
  border-radius: 16px;
  color: ${({ theme }: LabelProps) => (theme.dark ? COLORS.mlbGrey2 : COLORS.mlbGrey6)};
  &:hover {
    background: ${({ theme }: LabelProps) => (theme.dark ? COLORS.mlbGrey7 : COLORS.mlbGrey1)};
  }
  ${HiddenCheckbox}:checked + & {
    background: ${({theme} : LabelProps) => (theme.dark ? COLORS.linkBlueOnDark : COLORS.linkBlue)};
    border-color: ${({theme} : LabelProps) => (theme.dark ? COLORS.linkBlueOnDark : COLORS.linkBlue)};
    color: ${COLORS.mlbWhite};
  }

  ${HiddenCheckbox}:focus + & {
    outline: 2px solid ${COLORS.tabFocusColor};
  }
`;

export const Wrapper = styled(Label)`
  display: flex;
  position: relative;
  align-items: center;
`;

export const StyledCheckbox: AnyStyledComponent = styled.div`
  display: flex;
  flex: 0 0 13px;
  width: 13px;
  height: 13px;
  background: ${({ checked }: InputProps) => (checked ? COLORS.linkBlueOnDark : 'transparent')};
  border: 1px solid ${COLORS.mlbGrey2};
  border-radius: 2px;
  margin-right: 13px;
  position: relative;
  box-sizing: border-box;
  transform: translateZ(0); /* This is used Safari bug with the outline being cut off with column-count > 1 */

  ${IconWrapper} {
    position: absolute;
    left: 0;
    top: 0;
    display: none;
  }

  ${HiddenCheckbox}:checked + ${Wrapper} & {
    background: ${({ theme }: InputProps) => (theme.dark ? COLORS.linkBlueOnDark : COLORS.linkBlue)};
    border-color: ${({ theme }: InputProps) => (theme.dark ? COLORS.linkBlueOnDark : COLORS.linkBlue)};
    ${IconWrapper} {
      display: block;
    }
  }

  ${HiddenCheckbox}:focus + ${Wrapper} & {
    outline: 2px solid ${COLORS.tabFocusColor};
  }
`;

export const Span = styled.span`
  font-family: ${FONTS.primaryFont};
  font-size: 15px;
  color: ${({ theme }: LabelProps) => (theme.dark ? COLORS.mlbGrey2 : COLORS.mlbGrey6)};
  line-height: normal;
`;
